import { render, staticRenderFns } from "./integralAddress.vue?vue&type=template&id=5479cef0&scoped=true"
import script from "./integralAddress.vue?vue&type=script&lang=js"
export * from "./integralAddress.vue?vue&type=script&lang=js"
import style0 from "./integralAddress.vue?vue&type=style&index=0&id=5479cef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479cef0",
  null
  
)

export default component.exports